var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import "phaser";
import { __atlasname, __audioname, __cdnname, __charactername, __objectname, __uiname, __weaponname, } from "@/lib/variables";
import CoreProgressBar from "@/prefabs/core/ProgressBar";
import imageMetadata from "@assets/images/metadata.json";
import soundMetadata from "@assets/audio/metadata.json";
import UtilsScreen from "@/lib/utils/screen";
import path from "@/lib/utils/path";
import SplashGame from "@/lib/SplashGame";
var characterMetadata = imageMetadata.characters;
var objectMetadata = imageMetadata.objects;
var uiMetadata = imageMetadata.ui;
var audioMetadata = soundMetadata.audio;
var LoadingScene = /** @class */ (function (_super) {
    __extends(LoadingScene, _super);
    function LoadingScene() {
        return _super.call(this, { key: "LoadingScene" }) || this;
    }
    LoadingScene.prototype.init = function (params) {
        var _this = this;
        this.params = params;
        SplashGame.ResizeHandler.getInstance().onScaleResize(this, function () {
            return _this.resize();
        });
    };
    LoadingScene.prototype.preload = function () {
        var _this = this;
        var _a = UtilsScreen.safe_area(this), width = _a.width, height = _a.height;
        // logo
        this.logo = this.add.image(0, 0, "logo").setOrigin(0.5, 0);
        var o_y = -180; // offset y
        var o_r = 2; // offset radius
        // points
        this.graphics = this.add
            .graphics()
            .fillStyle(0x3be0d2)
            .fillCircle(120, height / 2 + 120 + o_y, 20 * o_r)
            .fillStyle(0x3a69e0)
            .fillCircle(220, height / 2 + 60 + o_y, 10 * o_r)
            .fillStyle(0xd27536)
            .fillCircle(300, height / 2 + 160 + o_y, 15 * o_r)
            .fillStyle(0x7e7721)
            .fillCircle(500, height - 80 + o_y, 20 * o_r)
            .fillStyle(0x5d185a)
            .fillCircle(200, height + o_y, 20)
            .fillStyle(0xf93072)
            .fillCircle(width - 280, height / 2 - 80 + o_y, 10 * o_r)
            .fillStyle(0x2fa7f9)
            .fillCircle(width - 380, height / 2 - 60 + o_y, 15 * o_r)
            .fillStyle(0xf9b42e)
            .fillCircle(width - 290, height / 2 + 60 + o_y, 25 * o_r)
            .fillStyle(0x38dd42)
            .fillCircle(width - 160, height / 2 + 120 + o_y, 35 * o_r)
            .fillStyle(0x175d57)
            .fillCircle(width - 290, height + o_y, 40 * o_r);
        // progress bar
        this.progressBar = new CoreProgressBar(this, 320, 50, 16);
        this.progressBar.setPosition(width / 2 - 160, height - 150 - 30);
        this.add.existing(this.progressBar);
        this.load.on("progress", function (value) {
            _this.progressBar.setValue(Math.trunc(value * 100));
        });
        // character
        this.character = this.add
            .image(width / 2 - 15, this.progressBar.y - 150, "logo_char")
            .setOrigin(0.5)
            .setScale(0.4);
        this.resize();
        // load assets
        this.loadImages();
        this.loadSpriteSheets();
        this.loadAudio();
        this.loadPlugin();
    };
    LoadingScene.prototype.create = function () {
        this.scene.start("GameplayScene", this.params);
    };
    LoadingScene.prototype.loadImages = function () {
        // load characters and weapons
        for (var index in characterMetadata) {
            this.load.image("char_" + index, path.join(__charactername, characterMetadata[index].character));
            this.load.image("weapon_" + index, path.join(__weaponname, characterMetadata[index].weapon));
        }
        // load game objects
        for (var _i = 0, objectMetadata_1 = objectMetadata; _i < objectMetadata_1.length; _i++) {
            var data = objectMetadata_1[_i];
            this.load.image(data.name, path.join(__objectname, data.src));
        }
        // load ui elements
        for (var _a = 0, uiMetadata_1 = uiMetadata; _a < uiMetadata_1.length; _a++) {
            var data = uiMetadata_1[_a];
            this.load.image(data.name, path.join(__uiname, data.src));
        }
    };
    LoadingScene.prototype.loadSpriteSheets = function () {
        this.load.spritesheet("deathAnimation", path.join(__atlasname, "anim_boom.png"), {
            frameWidth: 294,
            frameHeight: 239,
        });
    };
    LoadingScene.prototype.loadAudio = function () {
        for (var _i = 0, audioMetadata_1 = audioMetadata; _i < audioMetadata_1.length; _i++) {
            var data = audioMetadata_1[_i];
            this.load.audio(data.name, [path.join(__audioname, data.src)]);
        }
    };
    LoadingScene.prototype.loadPlugin = function () {
        this.load.plugin("rexvirtualjoystickplugin", path.join(__cdnname, "rexvirtualjoystickplugin.min.js"), true);
    };
    LoadingScene.prototype.resize = function () {
        var _a = UtilsScreen.safe_area(this), x_min = _a.x_min, x_max = _a.x_max, y_min = _a.y_min, y_max = _a.y_max, width = _a.width, height = _a.height;
        var _width = x_max - x_min;
        var _height = y_max - y_min;
        this.logo.setPosition(width / 2, y_min);
        var logo_w = this.logo.width * 0.4;
        var logo_h = this.logo.height * 0.4;
        var logo_s_x = Math.min(_width * 0.3, logo_w) / logo_w;
        var logo_s_y = Math.min(_height * 0.2, logo_h) / logo_h;
        var logo_s = Math.min(logo_s_x, logo_s_y);
        this.logo.setScale(logo_s);
        this.graphics.setPosition(x_min, y_min);
        this.graphics.setScale(1);
    };
    return LoadingScene;
}(Phaser.Scene));
export default LoadingScene;
